import React from "react";
import styled from "styled-components";
import { Container, FullContent } from "components/Grid";
import HTML from "components/HTML";

const Content = styled(FullContent)`
  padding: 3rem 0;
  background-color: #8bb140;
  color: #fff;
`;

const PageContent = (props) => {
  return (
    <Content>
      <Container>
        <HTML content={props.content} />
      </Container>
    </Content>
  );
};

export default PageContent;
